import React from 'react';
import complete from "../../img/complete.svg";

function ProfileComplete(){

    return (
       
        <>

<div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
       
    </div>
</div>

    <div class="col-sm-12">

<img src={complete} width="20%" style={{marginLeft:"40%", marginBottom:"50px", marginTop:"50px" }}/>
       
    </div>

</div>

        </>
    )
}

export default ProfileComplete;


